var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreesAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6458 9C20.4762 8.26706 21 7.19469 21 6C21 3.79086 19.2091 2 17 2C14.7909 2 13 3.79086 13 6C13 7.19469 13.5238 8.26706 14.3542 9C13.5238 9.73295 13 10.8053 13 12C13 13.9528 14.3994 15.5787 16.25 15.9298V21.25H7.75V18.9298C9.60065 18.5787 11 16.9528 11 15C11 13.8053 10.4762 12.7329 9.64582 12C10.4762 11.2671 11 10.1947 11 9C11 6.79086 9.20914 5 7 5C4.79086 5 3 6.79086 3 9C3 10.1947 3.52376 11.2671 4.35418 12C3.52376 12.7329 3 13.8053 3 15C3 16.9528 4.39935 18.5787 6.25 18.9298V21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H17.75V15.9298C19.6006 15.5787 21 13.9528 21 12C21 10.8053 20.4762 9.73295 19.6458 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesAlt4);
export default __webpack_public_path__ + "static/media/trees-alt-4.b7716eed30ae083aa6d48bf9f7e04d2c.svg";
export { ForwardRef as ReactComponent };